import React, { ReactNode } from "react";

import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { AxiosError } from "axios";

import { DEFAULT_CACHE_TIME } from "consts";

export const persistentQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error) => {
        if (error instanceof AxiosError && error.response?.status === 418) {
          return false;
        }
        return failureCount < 3;
      },
      staleTime: DEFAULT_CACHE_TIME,
      gcTime: DEFAULT_CACHE_TIME,
    },
  },
});

const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});

export const PersistentCacheContext = ({ children }: { children: ReactNode }) => (
  <PersistQueryClientProvider
    client={persistentQueryClient}
    persistOptions={{
      buster: "1761148800000", // 2025-10-22, 6pm
      persister,
    }}
  >
    {children}
  </PersistQueryClientProvider>
);

export const TempCacheContext = ({ children }: { children: ReactNode }) => <QueryClientProvider client={persistentQueryClient}>{children}</QueryClientProvider>;
